import { createActionGroup, props } from "@ngrx/store";
import { PaymentTerm } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export const DataPaymentTermsActions = createActionGroup({
    source: "Data / Payment Terms",
    events: {
        "Load": props<{ companyId: string; languageCode: string }>(),
        "Load Success": props<{ paymentTerms: PaymentTerm[] }>(),
        "Load Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
